// Importing All Images
import EmailVerifyimg from "./EmailVerifyimg.png";
import EmailImg from "./mail.png";
import Img1 from "./Path 7205.png";
import Img2 from "./Group 4083.png";
import Img3 from "./Path 7204.png";
import Unleash from "./unleash.png";
import Ignitegrowth from "./ignitegrowth.png";

// Importing All Icons
import { IoIosCloseCircleOutline } from "react-icons/io";
import { RxCross2, RxQuestionMark } from "react-icons/rx";
import { FaCheck } from "react-icons/fa6";

// Importing Loader
import FadeLoader from "react-spinners/FadeLoader";

// Exporting All Assets
const assets = {
  images: {
    EmailVerifyimg,
    EmailImg,
    Img1,
    Img2,
    Img3,
    Unleash,
    Ignitegrowth,
  },
  icons: {
    IoIosCloseCircleOutline,
    RxCross2,
    RxQuestionMark,
    FaCheck,
  },
  loaders: {
    FadeLoader,
  },
};

export default assets;
